import styled, { css } from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import ChevronLeft from '../../../../assets/icons/ChevronLeft.svg';
import ChevronOrange from '../../../../assets/icons/chevron_right_icon_orange.svg';

const sizes = {
  default: {
    fontWeight: 500,
    paddingX: '24px',
    paddingY: '12px',
    fontSize: '16px',
    lineHeight: '150%',
  },
  large: {
    fontWeight: 600,
    paddingX: '32px',
    paddingY: '14px',
    fontSize: '18px',
    lineHeight: '150%',
  },
  small: {
    fontWeight: 500,
    paddingX: '16px',
    paddingY: '11px',
    fontSize: '14px',
    lineHeight: '130%',
  },
};

export const Label = styled.div`
  font-weight: ${({ size }) => sizes[size].fontWeight};
  font-size: ${({ size }) => sizes[size].fontSize};
  line-height: ${({ size }) => sizes[size].lineHeight};
  color: ${colors.BLACK};
  margin: 0;
  width: max-content;
  display: flex;
  align-items: center;
  ${({ showarrow }) => showarrow === 'true' && css`
    background-image: url(${({ isIconLeftPosition }) => (isIconLeftPosition ? ChevronLeft : ChevronOrange)});
    background-repeat: no-repeat;
    background-position: ${({ isIconLeftPosition }) => (isIconLeftPosition ? 'center left' : 'center right')};
    padding-right: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '0px' : '26px')};
    padding-left: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '26px' : '0px')};
  `};
  ${({ showarrow, iconSrc }) => (showarrow === 'false' && iconSrc) && css`
    background-image: url(${iconSrc});
    background-repeat: no-repeat;
    background-position: ${({ isIconLeftPosition }) => (isIconLeftPosition ? 'center left' : 'center right')};
    padding-right: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '0px' : '26px')};
    padding-left: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '26px' : '0px')};
  `};
`;

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ size }) => sizes[size].paddingY} ${({ size }) => sizes[size].paddingX};
  background-color: transparent;
  cursor: pointer;
  border-radius: 1px;
  border: none;
  outline: 1px solid ${colors.BLACK};

  &:hover:enabled {
    outline: 1px solid #FFAF89;
  }

  &:focus {
    outline: 2px solid ${colors.BRAND_ORANGE};
  }

  &:active:enabled {
    outline: 1px solid ${colors.ORANGE_SHADES_DARK1};
  }

  &:disabled {
    outline: 1px solid ${colors.COOL_GREY};
    ${Label} {
      color: ${colors.DARK_GREY};
    };
    cursor: not-allowed;
  }
`;
